import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import LoadingSpinner from "../../Components/spinner";
import { gameTypes } from "../../services/staticData";

const Filters = ({ pagination, setPagination, categories, subCategories, tagsData, languages, setGames }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState(searchParams.get("search") || "");
  const [filtering, setFiltering] = useState(false);
  const [filters, setFilters] = useState({
    status: searchParams.get("status") || "3",
    tag: searchParams.get("tag") || "",
    language: searchParams.get("language") || "",
    category: searchParams.get("category") || "",
    subcategory: searchParams.get("subcategory") || "",
    type: searchParams.get("type") || "",
  });

  // Update URL parameters
  const updateUrlParams = (newParams) => {
    const params = new URLSearchParams(searchParams);
    Object.entries(newParams).forEach(([key, value]) => {
      if (value) {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    });
    params.set("page", "1"); // Always reset to page 1 on filter change
    setSearchParams(params);
  };

  // Sync internal state with URL on mount or URL change
  useEffect(() => {
    setQuery(searchParams.get("search") || "");
    setFilters({
      status: searchParams.get("status") || "3",
      tag: searchParams.get("tag") || "",
      language: searchParams.get("language") || "",
      category: searchParams.get("category") || "",
      subcategory: searchParams.get("subcategory") || "",
      type: searchParams.get("type") || "",
    });
  }, [searchParams]);

  // Handle dropdown changes
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const updates = { [name]: value };
    if (name === "category") {
      updates.subcategory = ""; // Reset subcategory when category changes
    }
    updateUrlParams(updates);
  };

  // Handle search text change
  const handleSearch = (e) => {
    const value = e.target.value;
    setQuery(value);
    const params = new URLSearchParams(searchParams);
    if (value) {
      params.set("search", value);
    } else {
      params.delete("search");
    }
    params.set("page", "1");
    setSearchParams(params);
  };

  // Reset all filters
  const resetFilters = () => {
    setQuery("");
    setFilters({
      status: "3",
      tag: "",
      language: "",
      category: "",
      subcategory: "",
      type: "",
    });
    setSearchParams({}); // Clear all search params
  };

  // Derived list of subcategories based on selected category
  const filteredSubCategories = subCategories?.filter(
    (sc) => !filters.category || sc.cat_id === parseInt(filters.category)
  );

  return (
    <div className="col-md-12 row g-2">
      {/* Search Filter */}
      <div className="col-md-3 py-1">
        <Form.Control
          type="text"
          placeholder="Search Games..."
          value={query}
          onChange={handleSearch}
          className="bg-dark text-light border-secondary shadow-sm"
        />
      </div>

      {/* Category Filter */}
      <div className="col-md-3 py-1">
        <Form.Select
          name="category"
          value={filters.category}
          onChange={handleFilterChange}
          className="bg-dark border-secondary text-light shadow-sm"
        >
          <option value="">All Categories</option>
          {categories?.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </Form.Select>
      </div>

      {/* Sub-Category Filter */}
      <div className="col-md-3 py-1">
        <Form.Select
          name="subcategory"
          value={filters.subcategory}
          onChange={handleFilterChange}
          className="bg-dark border-secondary text-light shadow-sm"
          disabled={!filters.category}
        >
          <option value="">{filters.category ? "All Sub-Categories" : "Select Category first"}</option>
          {filteredSubCategories?.map((sc) => (
            <option key={sc.id} value={sc.id}>
              {sc.name}
            </option>
          ))}
        </Form.Select>
      </div>

      {/* Tags Filter */}
      <div className="col-md-3 py-1">
        <Form.Select
          name="tag"
          value={filters.tag}
          onChange={handleFilterChange}
          className="bg-dark border-secondary text-light shadow-sm"
        >
          <option value="">All Tags</option>
          {tagsData?.map((m) => (
            <option key={m.id} value={m.id}>
              {m.name}
            </option>
          ))}
        </Form.Select>
      </div>

      {/* Language Filter */}
      <div className="col-md-3 py-1">
        <Form.Select
          name="language"
          value={filters.language}
          onChange={handleFilterChange}
          className="bg-dark border-secondary text-light shadow-sm"
        >
          <option value="">All Languages</option>
          {languages?.map((m, i) => (
            <option key={i} value={m.language}>
              {m.language}
            </option>
          ))}
        </Form.Select>
      </div>

      {/* Status Filter */}
      <div className="col-md-3 py-1">
        <Form.Select
          name="status"
          value={filters.status}
          onChange={handleFilterChange}
          className="bg-dark border-secondary text-light shadow-sm"
        >
          <option value="3">Active & Inactive</option>
          <option value="1">Active</option>
          <option value="0">Inactive</option>
          <option className="text-danger" value="2">
            Deleted
          </option>
        </Form.Select>
      </div>

      {/* Action Button */}
      <div className="col-md-1 py-1 d-flex align-items-center">
        <Button
          variant="outline-success"
          size="md"
          className="w-100"
          onClick={resetFilters}
          title="Reset Filters"
        >
          Reset
        </Button>
      </div>
    </div>
  );
};
export default Filters;
